<div class="container">
	<div class="row custom-wrapper">
		<div class="col-md-12">
				<div class="group-gap">

					<!-- Upload image -->
					<div class="avatar-upload" (click)="fileInput.click()">
						<div class="avatar-edit">
							<input type='file' id="imageUpload" accept=".png, .jpg, .jpeg" #fileInput (change)="uploadFile($event)" />
            </div>
            <div class="avatar-preview">
              <div id="imagePreview" [style.backgroundImage]="'url('+ imageUrl +')'">
              </div>
            </div>
          </div>
        </div>
    </div>
  </div>
</div>